import { BounceLoader } from 'react-spinners';

const COLOR = '#818CF8';

export type LoaderSize = 'sm' | 'md' | 'lg' | number;

function sizeToNum(size: LoaderSize): number {
  if (typeof size === 'number') {
    return size;
  }
  switch (size) {
    case 'sm':
      return 20;
    case 'md':
      return 30;
    case 'lg':
      return 40;
  }
}

export interface LoaderProps {
  size?: LoaderSize;

  /**
   * This prop can be used to control the loader's visibility.
   *
   * @todo Most call sites don't use this feature (because it isn't documented
   * very well in `react-spinners`). Some do, so we have to expose it, and do
   * what `react-spinners` does under the hood. It is possible to remove a lot
   * of logic from call sites by refactoring this.
   */
  loading?: boolean;
}

export const Loader = ({ size = 'md', loading = true }: LoaderProps) => {
  return <BounceLoader loading={loading} size={sizeToNum(size)} color={COLOR} />;
};
